var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dashboard-layout', {
    attrs: {
      "title": "찜한 기업 관리",
      "fullHeight": ""
    }
  }, [_c('template', {
    slot: "contents"
  }, [_vm.items.length ? [_c('v-row', {
    staticClass: "row-cols-lg-5"
  }, _vm._l(_vm.items, function (item) {
    var _item$userCompany, _item$userCompany$log, _item$userCompany2, _item$userCompany2$lo, _item$userCompany3, _item$userCompany4, _item$userCompany4$in, _item$userCompany4$in2, _item$userCompany4$in3, _item$userCompany5, _item$userCompany5$lo, _item$userCompany6, _item$userCompany7;
    return _c('v-col', {
      key: item._id,
      attrs: {
        "cols": "6"
      }
    }, [_c('v-card', {
      staticClass: "applied-card",
      attrs: {
        "rounded": "lg",
        "outlined": "",
        "href": `/companies/${item._userCompany}`
      }
    }, [_c('div', {
      staticClass: "pa-20 pa-md-24"
    }, [_c('v-img', {
      attrs: {
        "aspect-ratio": 166 / 36,
        "width": "100%",
        "contain": "",
        "src": item === null || item === void 0 ? void 0 : (_item$userCompany = item.userCompany) === null || _item$userCompany === void 0 ? void 0 : (_item$userCompany$log = _item$userCompany.logo) === null || _item$userCompany$log === void 0 ? void 0 : _item$userCompany$log.url
      }
    }, [_c('v-fade-transition', [_c('v-overlay', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !(item !== null && item !== void 0 && (_item$userCompany2 = item.userCompany) !== null && _item$userCompany2 !== void 0 && (_item$userCompany2$lo = _item$userCompany2.logo) !== null && _item$userCompany2$lo !== void 0 && _item$userCompany2$lo.url),
        expression: "!item?.userCompany?.logo?.url"
      }],
      attrs: {
        "absolute": "",
        "light": "",
        "color": "white"
      }
    }, [_c('image-overlay', [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$userCompany3 = item.userCompany) === null || _item$userCompany3 === void 0 ? void 0 : _item$userCompany3.name))])], 1)], 1)], 1)], 1), _c('v-img', {
      attrs: {
        "aspect-ratio": 284 / 150,
        "width": "100%",
        "cover": "",
        "src": item === null || item === void 0 ? void 0 : (_item$userCompany4 = item.userCompany) === null || _item$userCompany4 === void 0 ? void 0 : (_item$userCompany4$in = _item$userCompany4.introduction) === null || _item$userCompany4$in === void 0 ? void 0 : (_item$userCompany4$in2 = _item$userCompany4$in.images) === null || _item$userCompany4$in2 === void 0 ? void 0 : (_item$userCompany4$in3 = _item$userCompany4$in2[0]) === null || _item$userCompany4$in3 === void 0 ? void 0 : _item$userCompany4$in3.url
      }
    }, [_c('v-fade-transition', [_c('v-overlay', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !(item !== null && item !== void 0 && (_item$userCompany5 = item.userCompany) !== null && _item$userCompany5 !== void 0 && (_item$userCompany5$lo = _item$userCompany5.logo) !== null && _item$userCompany5$lo !== void 0 && _item$userCompany5$lo.url),
        expression: "!item?.userCompany?.logo?.url"
      }],
      attrs: {
        "absolute": "",
        "light": "",
        "color": "white"
      }
    }, [_c('v-layout', {
      staticClass: "black--text",
      attrs: {
        "row": "",
        "align-center": ""
      }
    }, [_c('v-icon', {
      staticClass: "mr-4",
      attrs: {
        "color": "black"
      }
    }, [_vm._v("mdi-domain")]), _c('span', [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$userCompany6 = item.userCompany) === null || _item$userCompany6 === void 0 ? void 0 : _item$userCompany6.name) + " ")])], 1)], 1)], 1)], 1), _c('div', {
      staticClass: "pa-20 pa-md-24"
    }, [_c('v-row', {
      staticClass: "row--small",
      attrs: {
        "align": "center"
      }
    }, [_c('v-col', [_c('p', {
      staticClass: "page-text--lg font-weight-medium"
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$userCompany7 = item.userCompany) === null || _item$userCompany7 === void 0 ? void 0 : _item$userCompany7.name) + " ")])]), _c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('like-btn', {
      attrs: {
        "params": {
          _userCompany: item._userCompany,
          type: _vm.USER_LIKE_TYPES.USER_COMPNY.value
        }
      },
      on: {
        "removed": function ($event) {
          return _vm.remove(item);
        }
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (_ref) {
          var active = _ref.active,
            toggle = _ref.toggle;
          return [_c('v-btn', {
            attrs: {
              "icon": "",
              "small": "",
              "text": "",
              "color": active ? 'yellow darken-1' : undefined
            },
            on: {
              "!click": function ($event) {
                $event.stopPropagation();
                $event.preventDefault();
                return toggle.apply(null, arguments);
              }
            }
          }, [_c('v-icon', [_vm._v(_vm._s(active ? "mdi-star" : "mdi-star-outline"))])], 1)];
        }
      }], null, true)
    })], 1)], 1)], 1)], 1)], 1);
  }), 1), _c('v-pagination', {
    attrs: {
      "value": _vm.page,
      "length": _vm.pageCount,
      "total-visible": 11,
      "color": "primary"
    },
    on: {
      "input": function (page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page
          })
        });
      }
    }
  })] : [_c('v-layout', {
    staticClass: "w-100 h-100 grey-f7 rounded-lg pa-20",
    attrs: {
      "column": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('p', {
    staticClass: "page-text--lg line-height-15 text-center mb-12 mb-lg-32"
  }, [_vm._v(" 안녕하세요, 사용자님. "), _c('br'), _vm._v(" 찜한 기업이 없습니다. ")]), _c('v-btn', {
    attrs: {
      "href": "/recruitments",
      "text": "",
      "height": "auto",
      "color": "transparent"
    }
  }, [_c('span', {
    staticClass: "grey-9--text"
  }, [_vm._v("채용공고 보러가기")])])], 1)]], 2)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }